import React, { createContext, useContext, useState } from "react";

interface Report {
  id: string;
  reportSource?: { source: string };
  [key: string]: any;
}

interface PropertyReportContextType {
  propertyId: string | null;
  propertyReportId: string | null;
  reports: Report[];
  isDocReport: boolean;
  loading: boolean;
  setPropertyReports: (
    propertyId: string | null,
    propertyReportId: string | null,
    reports: Report[],
    isDocReport: boolean
  ) => void;
  setLoading: (isLoading: boolean) => void;
}

const PropertyReportContext = createContext<PropertyReportContextType>({
  propertyId: null,
  propertyReportId: null,
  reports: [],
  isDocReport: false,
  loading: false,
  setPropertyReports: () => {},
  setLoading: () => {},
});

export const PropertyReportProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [propertyId, setPropertyId] = useState<string | null>(null);
  const [propertyReportId, setPropertyReportId] = useState<string | null>(null);
  const [reports, setReports] = useState<Report[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDocReport, setIsDocReport] = useState<boolean>(false);

  const setPropertyReports = (
    propertyId: string | null,
    reportId: string | null,
    newReports: Report[],
    isDocReport: boolean
  ) => {
    setPropertyId(propertyId);
    if (reportId) setPropertyReportId(reportId);
    setReports(newReports);
    setIsDocReport(isDocReport);
  };

  return (
    <PropertyReportContext.Provider
      value={{
        propertyId,
        propertyReportId,
        isDocReport,
        reports,
        loading,
        setPropertyReports,
        setLoading,
      }}
    >
      {children}
    </PropertyReportContext.Provider>
  );
};

export const usePropertyReportContext = () => useContext(PropertyReportContext);
